<template>
	<span columns="1" rows="12" class="max-w-full" v-click-outside="closeDropdown" ref="span">
		<Input :placeholder="$root.appConfig.language.destination" :fullwidth="true" :icon="true" :modelValue="destinationValue.title" @click.native="openDropdown()" :hasInputSlot="true">
			<template v-slot:input>
				<input
					readonly
					ref="destInput"
					class="inp"
					type="text"
					name="destination_raw"
					:value="destinationValue.title"
				/>
			</template>
			<template v-slot:after-icon>
				<LocationIcon/>
			</template>
		</Input>

		<MobileModal :visible="dropdownOpen" @close="closeDropdown">

			<div class="panelHead">
				<a v-for="continent in renderContinents" :key="continent.id" @click.prevent="selectContinent(continent, true)" :class="{active: selectedContinent == continent.id}">
					{{ continent.title }}
				</a>
			</div>
			<ul v-for="continent in filteredContinents" :key="continent.id">
				<li class="continent" v-if="selectedContinent != 0" @click.prevent="selectContinent(continent)">all hotels in {{ continent.title }}</li>
				<li class="continent" v-else @click.prevent="selectContinent(continent)">{{ continent.title }}</li>

				<li v-for="city in continent.cities" :key="city.id" class="city-item">
					<a @click.prevent="selectDestination(city)">{{ city.title }}</a>
					<ul>
						<li v-for="property in city.properties" :key="property.id">
							<a @click.prevent="selectDestination(property)">
								{{ property.title }} <PropertyTag v-if="property.tag" :title="property.tag.title" :color="property.tag.color"></PropertyTag>
							</a>
						</li>
					</ul>
				</li>

			</ul>

		</MobileModal>
	</span>
</template>
<script>

import ClickOutside from 'vue-click-outside'
import {
	LocationIcon,
	Input,
	MobileModal,
} from 'citizen-shared-components'
import PropertyTag from './PropertyTag'

export default {
	name: 'DestinationInput',
	components: {
		MobileModal,
		Input,
		LocationIcon,
		PropertyTag,
	},
	props: {
		allContinentsLabel: String,
		continents: Array,
		destination: [String, Number],
	},
	data(){
		return {
			selectedContinent: 0,
			dropdownOpen: false,

			searchterm: '',
		}
	},
	mounted(){
		this.searchterm = this.destinationValue.title
	},
	computed: {
		renderContinents(){
			return [
				{
					id: '0',
					title: this.allContinentsLabel,
					cities: [],
				},
				... this.continents
			]
		},
		filteredContinents(){
			if(this.selectedContinent != 0){
				return this.continents.filter(c => c.id == this.selectedContinent)
			}
			return this.continents
		},
		destinationValue(){
			let dest = {
				id: this.destination,
				title: this.$root.appConfig.language.destinationPlaceholder,
			}

			this.continents.map(c => {
				if(c.id == this.destination){
					dest.title = c.title
				}
				else {
					c.cities.map(ci => {
						if(ci.id == this.destination){
							dest.title = ci.title
						}

						else {
							ci.properties.map(p => {
								if (p.id == this.destination) {
									dest.title = p.title
								}
							})
						}
					})
				}
			})


			return dest
		},
	},
	methods: {
		openDropdown(){
			this.$emit('open')
			this.dropdownOpen = true
		},
		closeDropdown(){
			if(this.dropdownOpen === true) {
				this.$emit('close')
				this.dropdownOpen = false
			}
		},

		selectDestination(dest){
			this.$emit('close')
			this.$emit('destinationChange', dest.id)
			this.dropdownOpen = false
		},

		selectContinent(continent, keepOpen){
			this.selectedContinent = continent.id
			this.$emit('destinationChange', continent.id)
			if(!keepOpen) {
				this.dropdownOpen = false
			}
		},
	},
	directives: {
		ClickOutside
	},
}

</script>
<style lang="scss" scoped>
@import "@/assets/styles/app.scss";
@import "@/assets/styles/utils/_mixins.scss";
.dropdown {
	z-index: 32;

	left: 0;
	right: 0;
	top: 0;

	> * {
		padding: 0 1.5rem;
		opacity: 0.5;
		transition: all 0.3s;
		width: 100%;
		max-width: 75rem;
		margin-left: auto;
		margin-right: auto;
	}

	min-height: 100vh;
	max-height: 100vh;
	position: fixed;
	background-color: white;

	a.closer {
		top: 41px;
		right: 10px;
		width: auto;
		position: absolute;
	}
}
.modal-container {
	padding: 24px;
}
.panelHead {

	font-family: var(--font-family-bold);
	display: flex;
	justify-content: flex-start;
	padding: 66px 16px 0;

	box-shadow: var(--shadow);

	margin-left: -24px;
	margin-right: -24px;
	margin-top: -56px;
	margin-bottom: 16px;

	> a {
		font-size: 18px;
		line-height: 28px;
		padding: 12px 0px;
		margin: 0 8px;
		cursor: pointer;
		color: #4C4C4C;
		position: relative;

		&:after {
			content: '';
			display: block;
			height: 1px;
			width: 100%;
			position: absolute;
			bottom: 0;
			left: 0;

			transition: var(--transition-opacity);
			opacity: 0;
		}

		&.active,
		&:hover {
			color: #000000;

			&:after {
				opacity: 1;
				background: var(--primary-red);
			}
		}
	}
}

ul {
	list-style: none;
	margin-bottom: 16px;

	li {
		font-size: 12px;
		line-height: 20px;

		&.continent {
			margin-bottom: -4px;
			cursor: pointer;
		}

		&.city-item {
			margin-top: 16px;

			> a {
				font-family: var(--font-family-bold);
			}
		}

		ul	{
			margin-bottom: 8px;
		}
	}
	a {
		display: block;
		font-size: 14px;
		line-height: 20px;
		margin-bottom: 8px;
		cursor: pointer;
	}
}

@include md {
	.modal-container {
		padding: 0;
		width: 343px;
	}
	.modal-body {
		position: relative;

		> ul {
			padding: 16px 24px;
		}
	}
	.panelHead {
		position: sticky;
		top: 0;
		margin: 0;
		padding: 8px 18px 0;
		background: var(--primary-white);
		z-index: 2;
		width: 343px; //calc(100% + 11px);
	}
}
@media (min-width: 1192px) {
	.panelHead {
		min-width: 332px;
	}
}
</style>
<style lang="scss">
@import "@/assets/styles/app.scss";
@import "@/assets/styles/utils/_mixins.scss";
@include mdx {
	// "Sticky"
	.modal-container {
		overflow: auto;

		.modal-close {
			position: fixed;
			z-index: 2;
		}
		.panelHead {
			position: sticky;
			top: -56px;
			background: var(--primary-white);
		}
	}
}
</style>